var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-type"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"content"},[_vm._t("content"),_vm._t("reference-image"),_vm._t("hyperlinks-documents")],2),_c('div',{staticClass:"content-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }